export const CREATE_SCHEDULING_HOLD = 'createSchedulingHold';
export const SCHEDULING_WIDGET_CONFIG = 'schedulingWidgetConfig';
